import type { OperationalNote, OpsSeverity } from "../types";
import { asString, asStringArray, parseBoldEntriesV3 } from "./parse-bullets-v3";

// ## Operational Notes
// v0.3: bullet-list entries (was H3-headed in v0.2). `description` is a
// bullet field, not a blockquote like v0.2's `content`.

const SEVERITY_VALUES: ReadonlySet<OpsSeverity> = new Set(["info", "warning", "critical"]);

export function parseOperationalNotesV3(body: string): OperationalNote[] {
  const entries = parseBoldEntriesV3(body, "OperationalNotes");
  return entries.map((entry) => {
    const p = entry.properties;
    const rawSeverity = (asString(p.severity) ?? "info").toLowerCase();
    const severity: OpsSeverity = SEVERITY_VALUES.has(rawSeverity as OpsSeverity)
      ? (rawSeverity as OpsSeverity)
      : "info";
    const description = asString(p.description);
    return {
      id: entry.id,
      label: asString(p.label) ?? entry.id,
      type: asString(p.type) ?? "info",
      severity,
      why: asString(p.why),
      applies_to: asStringArray(p.applies_to),
      description,
      // Legacy compat — renderer still reads `note.content` until Phase 5.
      content: description,
    };
  });
}
